import { Button, Chip, Grid, Paper, Typography } from "@material-ui/core";
import { useStyles } from "./valuationAppendedFilters.styles";
import jMoment from "moment-jalaali";

const ValuationAppendedFilters = (props) => {
  const { filters, setFilters } = props;
  const classes = useStyles();

  const getFilterName = (filter) => {
    switch (filter) {
      case "from_date":
        return "از تاریخ";
      case "to_date":
        return "تا تاریخ";
      case "id":
        return "شناسه";
      case "full_id":
        return "شناسه کل";
      case "first_name":
        return "نام";
      case "last_name":
        return "نام خانوادگی";
      case "user_first_name":
        return "نام ارزیاب";
      case "user_last_name":
        return "نام خانوادگی ارزیاب";
      case "user_work_title":
        return "نام دفتر کارشناسی";
      case "phone_number":
        return "شماره تلفن مشتری";
      case "city":
        return "شهر";
      case "postal_code":
        return "کد پستی";
      case "address":
        return "آدرس";
      default:
        return "نامعتبر";
    }
  };

  const getFilterValue = (filter, value) => {
    switch (filter) {
      case "from_date":
      case "to_date":
        return jMoment(value).format("jYYYY/jMM/jDD");
      case "id":
      case "full_id":
      case "user_name":
      case "phone_number":
      case "city":
      case "postal_code":
      case "address":
        return value;
      default:
        return value;
    }
  };

  const handleRemoveFilter = (filter, type) => {
    var newFilters = {};
    if (type === "single") {
      newFilters = { ...filters };
      delete newFilters[filter];
    }
    setFilters(newFilters);
  };

  const hasFilters = () => !Object.values(filters).every((x) => x === null || x === "");

  return (
    hasFilters() && (
      <Grid container>
        <Grid item xs={12}>
          <Paper className={classes.filtersPaper}>
            <Grid container>
              <Grid item xs={10}>
                <Grid container spacing={1} alignItems='center'>
                  <Grid item>
                    <Typography variant='body'>فیلترهای اعمال شده:</Typography>
                  </Grid>
                  {Object.keys(filters).map((filter) => (
                    <Grid item>
                      <Chip
                        variant='outlined'
                        label={getFilterName(filter) + ": " + getFilterValue(filter, filters[filter])}
                        onDelete={() => handleRemoveFilter(filter, "single")}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid item xs={2}>
                <Button fullWidth variant='contained' color='primary' onClick={() => handleRemoveFilter(null, "all")}>
                  حذف همه فیلترها
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    )
  );
};

export default ValuationAppendedFilters;
